import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, SvgIcon } from '@/components';

import styles from './SocialAuthButtons.module.sass';
import { TelegramAuth } from './TelegramAuth';
import { TwitterAuth } from './TwitterAuth';

type SocialAuthModeTypes = 'signIn' | 'signUp';

interface SocialAuthButtonsProps {
  mode?: SocialAuthModeTypes;
  onClickAuthGoogle: () => void;
  gaCallback?: () => void;
  disabled?: boolean;
}

const SocialAuthButtons: FC<SocialAuthButtonsProps> = ({
  mode,
  onClickAuthGoogle,
  gaCallback,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const googleButtonText = useMemo(() => {
    if (mode === 'signIn') {
      return t('translation.sign_in_with_google');
    }

    return t('translation.continue_with_google');
  }, [mode, t]);

  return (
    <div className={styles.socials}>
      <div className={styles.main}>
        <Button
          size="xl"
          type="shadow"
          corner="rect"
          onClick={onClickAuthGoogle}
          fullwidth
          disabled={disabled}
        >
          <SvgIcon name="google-short-color" className={styles.googleIcon} />
          {googleButtonText}
        </Button>
      </div>

      <div className={styles.other}>
        <TelegramAuth gaCallback={gaCallback} disabled={disabled} />
        <TwitterAuth disabled={disabled} />
      </div>
    </div>
  );
};

export default SocialAuthButtons;
